module.exports = __webpack_public_path__ + "static/media/13n.6800771b.png";